import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
} from "@mui/material";
import { useTranslation } from "react-i18next";

export default function CheckBox(props) {
  const { t } = useTranslation();
  const {
    name,
    value,
    onChange,
    width,
    error,
    required,
    helperText,
    ...other
  } = props;

  function onCheckChange(e) {
    onChange({
      target: {
        name: name,
        value: e.target.checked,
      },
    });
  }

  return (
    <FormControl
      variant="outlined"
      sx={{
        width: width || "100%",
      }}
      required={required}
      {...(error && { error: true })}
    >
      <FormControlLabel
        label={
          <span style={{ fontWeight: "bold" }}>{t(`FORM.FIELD.${name}`)}</span>
        }
        control={
          <Checkbox
            name={name}
            color="primary"
            checked={value !== false}
            onChange={onCheckChange}
            required={required}
            {...other}
          />
        }
      />
      {error && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}
